import DiscountList from './List';
import DiscountForm from './Form';
import DiscountImport from './Import';


export default {
    path: 'cadastros',
    redirect: '/cadastros/cupons-desconto',
    name: 'Cadastro Cupons Desconto',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'cupons-desconto',
            name: 'list-discount',
            component: DiscountList,
            meta: {
                requiresAuth: true,
                label: 'Listar Cupons Desconto'
            }
        },
        {
            path: 'cupons-desconto/novo',
            name: 'new-discount',
            component: DiscountForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Cupom Desconto'
            }
        },
        {
            path: 'cupons-desconto/importar',
            name: 'import-discount',
            component: DiscountImport,
            meta: {
                requiresAuth: true,
                label: 'Importar Cupons Desconto'
            }
        },
        {
            path: 'cupons-desconto/:id',
            name: 'edit-discount',
            component: DiscountForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Cupom Desconto'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/discount/router.js